<template>
    <Dialog :open="open" @update:open="onOpenChange">
        <DialogContent
            :class="[
                'block max-h-[85vh] overflow-y-auto border-black/10 bg-white p-4 text-left text-gray-900 dark:border-white/10 dark:bg-[#161926] dark:text-white',
                sizeClasses,
            ]"
        >
            <div :class="`my-1 ${padding}`">
                <slot></slot>
            </div>
        </DialogContent>
    </Dialog>
</template>

<script>
import { Dialog, DialogContent } from "@/components/ui/dialog";

/**
 * Wrapper de compatibilidade: mesma API do Modal antigo (open, size,
 * padding, @close) por cima do Dialog shadcn/reka-ui, que resolve o
 * empilhamento overlay/painel por construção.
 */
export default {
    name: "Modal",
    props: {
        open: { type: Boolean, default: false },
        size: { type: String, default: "md" },
        padding: { type: String, default: "px-3" },
    },

    components: {
        Dialog,
        DialogContent,
    },

    computed: {
        sizeClasses() {
            const sizes = {
                xs: "sm:max-w-xs",
                sm: "sm:max-w-sm",
                md: "sm:max-w-md",
                lg: "sm:max-w-lg",
                xl: "sm:max-w-xl",
                "2xl": "sm:max-w-2xl",
                "3xl": "sm:max-w-3xl",
                "4xl": "sm:max-w-4xl",
                "5xl": "sm:max-w-5xl",
                "6xl": "sm:max-w-6xl",
                "7xl": "sm:max-w-7xl",
                screen: "sm:max-w-none sm:w-[55vw]",
                full: "sm:max-w-full w-full",
            };

            return sizes[this.size] || sizes.md;
        },
    },

    methods: {
        onOpenChange(value) {
            if (!value && this.open) {
                this.$emit("close");
            }
        },
    },
};
</script>
